<template>
	<brows-layout @edit="$emit('edit')" @next="$emit('next')" class="auth">
		<AuthDesc></AuthDesc>
		<el-form label-position="left" label-width="85px">
			<!-- <el-form-item v-if="!is18" :label="!is18 ? '超級英雄' : '夥伴'">
				<div class="col" gutter="10" align-x="left">
					<el-form-item v-for="(member, i) in editStoryData.team_members" :key="i" :label="member.name">
						法定代理人：<template v-if="member.parent">{{member.parent}}</template>
						<span v-else class="color-danger">尚未填寫</span>
					</el-form-item>
				</div>
			</el-form-item> -->
			<el-form-item :label="!is18 ? '輔導員' : '代表人'">
				<template v-for="(counselor, i) in editStoryData.counselors">{{counselor.name}}<br :key="i"></template>
			</el-form-item>
			<el-form-item label="同意授權">
				本人「{{editStoryData.agree_authorize ? "同意" : "不同意"}}」下列條款：
			</el-form-item>
		</el-form>
		<el-button slot="button" @click="$emit('next')" type="info">略過</el-button>
		<AuthDesc2></AuthDesc2>
	</brows-layout>
</template>

<script>
import BrowsLayout from "./BrowsLayout.vue";
import AuthDesc from "./AuthDesc.vue";
import AuthDesc2 from "./AuthDesc2.vue";
import { mapState } from "vuex";

export default {
	props: ["is18"],
	data() {
		return {};
	},
	computed: {
		...mapState("story", ["editStoryData"])
	},
	methods: {},
	created() { },
	mounted() { },
	components: {
		BrowsLayout,
		AuthDesc,
		AuthDesc2,
	}
};
</script>

<style lang="scss" scoped>
.auth {
	font-size: 14px;

	.title {
		margin-bottom: 16px;
	}

	.content {
		padding-left: 20px;
	}

	.data-line {
		margin-bottom: 10px;

		.label {
			width: 85px;
		}

		.member {
			margin-right: 47px;
		}

		.agent {
			.name {
				margin-right: 35px;
				width: 60px;
			}
		}
	}
}
</style>